import React, {
        useEffect, useRef, useState }   from 'react';
import { Link, Params  }                from "react-router-dom";
import * as Dnd                         from "@dnd-kit/core";

import * as DistanceType                from 'shared/types/Distance';
import * as UserType                    from 'shared/types/User';
import * as ManifestType                from 'shared/types/Manifest';
import * as VehicleType                 from 'shared/types/Vehicle';
import * as OrderType                   from 'shared/types/Order';
import * as WSPayloadType               from 'shared/types/WSPayload';
import rehash                           from 'shared/utils/rehash';
import hashById                         from 'shared/utils/hashById';
import dayjs                            from 'shared/utils/day-timezone';

import Alert                            from 'utils/Alert';
import getApiPromise                    from 'utils/getApiPromise';
import tectransit                       from 'utils/TecTransit'
import MapOptions                       from 'utils/MapOptions';
import MapVehicle                       from 'utils/MapVehicle';
import getAgencyEarliestOpenAfter       from "utils/getAgencyEarliestOpenAfter";
import routeStyles                      from 'utils/routeStyles';
import * as MenuItem                    from 'components/MenuItem';
import withRouter                       from 'components/withRouter';
import DraftVehicleManifest             from 'Dispatcher/utils/DraftVehicleManifest';
import * as WhiteboardContextType       from 'Dispatcher/utils/WhiteboardContext';
import VehicleManifests                 from 'Dispatcher/components/VehicleManifests';
// import FixedRouteWhiteboardContext      from 'Dispatcher/components/FixedRouteWhiteboardContext'; // temporarily commented out until fixed
import OnDemandWhiteboardContext        from 'Dispatcher/components/OnDemandWhiteboardContext';

interface CardsViewProps {
    context                     : WhiteboardContextType.WhiteboardContext,
    createVehicleManifests      : ( vehicleManifests:DraftVehicleManifest[] )=>void;
    forceRefreshAgencyManifest? : () => void;
}
const CardsView : React.FC<CardsViewProps> = props => {
    const [draftVehicleManifestsById,setDraftVehicleManifestsById] = React.useState<Record<string,DraftVehicleManifest>>(
        props.context.draftVehicleManifestsById
    );
    const [schedulablesDivSyle,setSchedulablesDivStyle] = React.useState<React.CSSProperties>({maxHeight:'300px',overflowY:'auto',scrollbarWidth:'none'});
    const [stepsDivStyle,setStepsDivStyle] = React.useState<React.CSSProperties>({maxHeight:'600px',overflowY:'auto',scrollbarWidth:'none'});

    // @ts-expect-error
    window.toggleScrolls = ( onOff:boolean ) => {
        if( onOff ) {
            setSchedulablesDivStyle({maxHeight:'300px',overflowY:'auto',scrollbarWidth:'none'});
            setStepsDivStyle({maxHeight:'600px',overflowY:'auto',scrollbarWidth:'none'});
        }
        else {
            setSchedulablesDivStyle({maxHeight:'none'});
            setStepsDivStyle({maxHeight:'none'});
        }
    }

    const onDragEnd = ( event:Dnd.DragOverEvent ) => {
        setSchedulablesDivStyle({maxHeight:'300px',overflowY:'auto',scrollbarWidth:'none'});
        try {
            const newDraftVehicleManifestbyId = {
                ...draftVehicleManifestsById,
                ...props.context.onDragEnd(event.active,event.over)
            }
            props.context.setDraftVehicleManifestsbyId(newDraftVehicleManifestbyId);
            setDraftVehicleManifestsById(newDraftVehicleManifestbyId);
        }
        catch( err ) {
            props.context.alert.set(`Cannot handle DnD (${(err as Error).message})`,6000);
        }
    };
    const onDragStart = ( event: Dnd.DragStartEvent ) => {
        setSchedulablesDivStyle({overflowY: 'hidden', pointerEvents: 'none', maxHeight:'300px', scrollbarWidth:'none'})
    }
    const draftVehicleManifests = Object.values(draftVehicleManifestsById);
    const agencyManifestErrors  = ManifestType.AgencyManifest.getProblems(props.context.agencyManifest)
    return (
        <Dnd.DndContext onDragEnd={onDragEnd} onDragStart={onDragStart} autoScroll={false}>
            <div style={{textAlign:'center'}}>
                <div>
                    { (agencyManifestErrors.length>0)
                        ? (<div style={{color:'red'}}>Agency manifest got <b>{agencyManifestErrors.length}</b> errors</div>)
                        : (<div>{props.context.getHeaderText()}</div>)}
                    { props.context.agencyManifest.message && (<div>
                        {props.context.agencyManifest.message}
                    </div>) }
                    { (agencyManifestErrors.length===0) && (<div>
                        Total distance: <b>{DistanceType.fromMeters(draftVehicleManifests.reduce((acc,dvm)=>acc+dvm.originalVm.distance,0)).text}</b>
                    </div>) }
                    Click <Link to="/Dispatcher/OnDemand/Whiteboard/map">here</Link> to see routes on a map.
                </div>
                <div style={schedulablesDivSyle}>
                    {props.context.getSchedulablesTable()}
                </div>
                <hr style={{background:'black',height:'5px'}}/>
                <VehicleManifests
                    vehicleManifests    = { draftVehicleManifests.map(dvm=>dvm.originalVm) }
                    vehiclesById        = { props.context.vehiclesById }
                    driversById         = { props.context.driversById }
                    onDropOnVehicle     = { ( vehicleId, draggable, schedulable ) => {
                        return props.context.onDropOnVehicle(vehicleId,draggable,schedulable);
                    }}
                    getStatus           = { ( ndx ) => {
                        const dvm      = draftVehicleManifests[ndx];
                        const problems = [props.context.vehiclesById[dvm.originalVm.vehicle_id]?.unavailability_reason,...(dvm.problems||[])].filter(p=>!!p) as string[];
                        const title    = `VM #${dvm.originalVm._id}: ${dvm.originalVm.message||''}`;
                        if( problems.length>0 )
                            return (<span style={{color:'red'}}><strong title={`${title}\n${problems.join('\n')}`}>{problems.length} problem(s)</strong></span>);
                        if( !dvm.isIntact )
                            return (<span style={{color:'green'}}><strong title={title}>draft</strong></span>);
                        return (<span style={{color:'green'}}><strong title={title}>ok</strong></span>);
                    }}
                    getStops            = { ( ndx ) => {
                        return props.context.getDraftVehicleManifestStops(draftVehicleManifests[ndx]);
                    }}
                    getDistance         = { ( ndx ) => {
                        const dvm = draftVehicleManifests[ndx];
                        if( (dvm.schedulables.length===0) )
                            return '0 mi';
                        if( !dvm.isIntact )
                            return '??';
                        return DistanceType.fromMeters(dvm.originalVm.distance).text;
                    }}
                    getSteps            = { ( ndx ) => {
                        return <div style={stepsDivStyle}>{props.context.getDraftVehicleManifestSteps(draftVehicleManifests[ndx])}</div>;
                    }}
                />
                <hr style={{background:'black',height:'5px'}}/>
                <button className="btn-theme" style={{margin:'auto'}} onClick={(e:React.MouseEvent<HTMLButtonElement>)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    if( e.shiftKey && props.forceRefreshAgencyManifest ) {
                        // If we the shift button is pressed then let's just force refresh agency manifest
                        return props.forceRefreshAgencyManifest();
                    }
                    const notYetScheduledCount = props.context.getNotYetScheduledCount();
                    if( notYetScheduledCount>0 ) {
                        if( e.shiftKey && props.forceRefreshAgencyManifest ) {
                            // If we have not scheduled orders and the shift button is pressed then let's just
                            // force refresh agency manifest
                            return props.forceRefreshAgencyManifest();
                        }
                        props.context.alert.set(`There are ${notYetScheduledCount} item(s) still to schedule`,5000);
                        return;
                    }
                    if( draftVehicleManifests.every(dvm=>(dvm.isIntact && Number.isInteger(dvm.originalVm.requested_at))) ) {
                        if( !window.confirm(`All vehicle manifests are unchanged and have already been requested a confirmation of. Would you like to re-request it?`) ) {
                            props.context.alert.set(`Cancelled re-requesting of ${draftVehicleManifests.length} unchanges vehicle manifests`,5000);
                            return;
                        }
                    }
                    return props.createVehicleManifests(draftVehicleManifests);
                }}>
                    Create Vehicle Manifests
                </button>
                &nbsp;
            </div>
        </Dnd.DndContext>
    );
}

interface MapsViewProps {
    context : WhiteboardContextType.WhiteboardContext;
    alert: { set: (msg:string,timeout?:number)=>void };
}

class MapViewVehicle extends MapVehicle {
    protected stepsByOrderId = {} as Record<string,{
        pickupStep?  : ManifestType.Step.Hydrated<OrderType.Order<string>>,
        dropoffStep? : ManifestType.Step.Hydrated<OrderType.Order<string>>
    }>;
    constructor( googleMap:google.maps.Map, dvm?:DraftVehicleManifest ) {
        super(googleMap);
        // Iterate over all steps in draft vehicle manifest and see
        // which step each order gets picked up or dropped off.
        // Handle a really strange case if `dvm` is empty
        if( dvm && dvm.isIntact ){
            this.stepsByOrderId = (dvm.steps||[]).reduce((acc,step) => {
                step.dropoffs?.forEach( o => {
                    if( !acc[o._id!] )
                        acc[o._id!] = {};
                    acc[o._id!].dropoffStep = step;
                });
                step.pickups?.forEach( o => {
                    if( !acc[o._id!] )
                        acc[o._id!] = {};
                    acc[o._id!].pickupStep = step;
                });
                return acc;
            },{} as typeof this.stepsByOrderId);
        }
        else{
            this.stepsByOrderId = {};
        }
    }
    describeOrder( o:OrderType.Order,event:OrderType.Event ) {
        const orderDesc = (o.type==='pickup_ordered_at')?'Pickup':(o.type==='dropoff_ordered_at'?'Dropoff':o.type);
        const userDesc  = o.user ? o.user.name : `#${o.user_id}`;
        // If describeOrder is called with a pickup event, then the even step is in the pickupStep, else the dropoffStep
        const eventStep = (o.pickup===event) ? this.stepsByOrderId[o._id!]?.pickupStep : this.stepsByOrderId[o._id!]?.dropoffStep;
        // TODO:
        // See what happens if draft vehicle manifest gets changed by dispatcher dragging orders between vehicles.
        // In this case dmv.isIntact will be `false` but what will be the values of `step.seconds` and can we even trust
        // them? To be further researched and tested.
        const eventMs   = eventStep?.seconds ? (eventStep.seconds*1000) : event.eta;
        // Convert eventMs, if any, info a string. Else just show n/a
        const eventDesc = eventMs ? dayjs(eventMs).tz(tectransit.agency.time_zone).format(tectransit.timeFormat) : 'n/a';
        return `Order for ${orderDesc} of user <b>${userDesc}</b> at <b>${eventDesc}</b>`;
    }
}

const MapView: React.FC<MapsViewProps> = ({ alert, context }) => {
    // So... what the heck are we doing here?
    // We are reducing the number of calls to the backend APIs
    //
    // The API referred below is POST to "/api/dispatcher/ondemand/vehicleManifest/directions"
    //
    // Imagine this sequence:
    // 1. User loads cards view
    // 2. User switches to map view, takes a look at the routes of a few vehicles
    //    - The API gets call with dehydrated VMs of those vehicles
    // 3. User switches back to cards view
    // 4. User switches to map view again to take a look at the same vehicles.
    //    - the API gets called again with the same arguments and returns the same results.
    //
    // If we cache the routes returned from the API solely within the state of this `MapView`
    // component, then as soon as the component is gone from the webpage, then the cache is
    // gone as well. And in step #4 we will have to call the backend API again for the same
    // vehicles. So ... how do avoid this? Of course, we need to save the values returned by
    // the API somewhere where it won't get lost once MapView is gone. And where would that be?
    // The existing whiteboard context of course! Because the `context` variable stays on the
    // page as long as the page is loaded, regardless of the view.
    //
    // How do we do this if the type of Whiteboard context is already set and there is no way
    // to stick another property in there? Easy. We just cast the type of context to its type
    // with that property added. What can go wrong? Nothing. Because all other places of the
    // code does not know about the existance of this property and cannot refer to it.
    //
    // It is kinda a hack but it does reduce the number of API calls we need to call when
    // the whiteboard views are changed back and forth.
    const extendedContext = context as WhiteboardContextType.WhiteboardContext & {
        apiResultsByVid : Record<number,WSPayloadType.Vehicle.Hydrated>;
    };
    // If vehiclesById are empty then initialize it
    extendedContext.apiResultsByVid ||= {};

    const panelWidth         = 200;
    const [selectedVehicleIds, setSelectedVehicleKeys] = useState<Set<number>>(new Set());
    const mapRef              = useRef<HTMLDivElement | null>(null);
    const googleMap           = useRef<google.maps.Map | null>(null);
    const mapBoundaries       = useRef<google.maps.Polyline[]>([]);
    const mapViewVehicleByVid = useRef<Record<string,MapViewVehicle>>({});

    useEffect(() => {
        try {
            if (!mapRef.current)
                return;
            googleMap.current = tectransit.getGoogleMap(
                mapRef.current,
                new MapOptions(MapOptions.getBounds(tectransit.getAgencyBoundary(), -0.0625))
            );
            const boundaries = tectransit?.agency?.boundaries || [];
            mapBoundaries.current = boundaries.map((boundary: any, ndx: number) => {
                return new google.maps.Polyline({
                    strokeColor     : MapVehicle.boundaryColors[ndx % MapVehicle.boundaryColors.length],
                    strokeOpacity   : 1.0,
                    strokeWeight    : 3,
                    map             : googleMap.current!,
                    path            : boundary,
                });
            });
        }
        catch (err) {
            alert.set(`Initialization error (${(err as Error).message})`);
        }
    }, []);

    const draftVehicleManifests = Object.values(context.draftVehicleManifestsById);
    const agencyManifestErrors  = ManifestType.AgencyManifest.getProblems(context.agencyManifest)
    return (
        <table style={{ width: "100%" }}>
        <tbody>
            <tr>
                <td colSpan={2} align='center'>
                    { (agencyManifestErrors.length>0)
                        ? (<div style={{color:'red'}}>Agency manifest got <b>{agencyManifestErrors.length}</b> errors</div>)
                        : (<div>{context.getHeaderText()}</div>)}
                    { context.agencyManifest.message && (<div>
                        {context.agencyManifest.message}
                    </div>) }
                    { (agencyManifestErrors.length===0) && (<div>
                        Total distance: <b>{DistanceType.fromMeters(draftVehicleManifests.reduce((acc,dvm)=>acc+dvm.originalVm.distance,0)).text}</b>
                    </div>) }
                    Click <Link to="/Dispatcher/OnDemand/Whiteboard/cards">here</Link> to see routes as cards.
                </td>
            </tr>
            <tr>
                <td style={{ width: `${panelWidth}px`, verticalAlign: "top" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                        {context.agencyManifest.vehicleManifests.map( vm => {
                            const style = routeStyles[Number(vm.vehicle_id) % routeStyles.length];
                            const dvm   = context.draftVehicleManifestsById[vm.vehicle_id];
                            return (
                                <tr
                                    key     = {vm.vehicle_id}
                                    style   = {{
                                        ...style,
                                        border : "1px solid #999"
                                    }}
                                    onClick = {async () => {
                                        // IDEA:
                                        // If we replace Set with Record<number,number> then we will be
                                        // able to use deleteKey() from utils and the code will get shorter
                                        const newSelectedVehicleIds = new Set(selectedVehicleIds);
                                        if( selectedVehicleIds.has(vm.vehicle_id) ) {
                                            // Deselect: remove from set
                                            newSelectedVehicleIds.delete(vm.vehicle_id);
                                            setSelectedVehicleKeys(newSelectedVehicleIds);
                                            // and from the map
                                            mapViewVehicleByVid.current[vm.vehicle_id]?.remove();
                                            delete mapViewVehicleByVid.current[vm.vehicle_id];
                                        }
                                        else {
                                            try {
                                                // fetch if not cached, then update and store
                                                if( !extendedContext.apiResultsByVid[vm.vehicle_id] ) {
                                                    const dehydratedVehicle = await getApiPromise<WSPayloadType.Vehicle.Dehydrated>(
                                                        "/api/dispatcher/ondemand/vehicleManifest/directions",
                                                        "POST",
                                                        context.dehydratedAgencyManifest.vehicleManifests.find(dvm=>(dvm.vehicle_id===vm.vehicle_id))
                                                    );
                                                    if (dehydratedVehicle.err || !dehydratedVehicle)
                                                        throw new Error(dehydratedVehicle?.err||'Unknown error')
                                                    extendedContext.apiResultsByVid[vm.vehicle_id] = WSPayloadType.Vehicle.hydrate(
                                                        dehydratedVehicle,
                                                        context.agencyManifest.ordersById as unknown as Record<string, OrderType.Order>
                                                    );
                                                }
                                                const mapViewVehicle = new MapViewVehicle(googleMap.current!,context.draftVehicleManifestsById[vm.vehicle_id]);
                                                mapViewVehicle.update(extendedContext.apiResultsByVid[vm.vehicle_id]);
                                                mapViewVehicleByVid.current[vm.vehicle_id] = mapViewVehicle;
                                                newSelectedVehicleIds.add(vm.vehicle_id);
                                                setSelectedVehicleKeys(newSelectedVehicleIds);
                                            }
                                            catch( err ) {
                                                alert.set(`Cannot get directions for vehicle #${vm.vehicle_id} (${(err as Error).message})`,3000);
                                            }
                                        }
                                    }}
                                >
                                    <td
                                        style={{
                                            width       : `${panelWidth - 20}px`,
                                            padding     : "5px",
                                            cursor      : "pointer",
                                        }}
                                    >
                                        <strong>Fleet #: {vm.vehicle_id} {(dvm && !dvm.isIntact)?'(draft)':''}</strong>
                                    </td>
                                    <td
                                        style={{
                                            width       : "20px",
                                            fontWeight  : "bold",
                                            fontSize    : "medium",
                                            textAlign   : "center",
                                            cursor      : "pointer",
                                        }}
                                    >
                                        {selectedVehicleIds.has(vm.vehicle_id) ? "✓" : ""}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                    </table>
                </td>
                <td>
                    <div
                        id      = "map"
                        ref     = {mapRef}
                        className="map-card"
                        style   = {{ height: `${window.innerHeight - 60}px` }}
                    />
                </td>
            </tr>
        </tbody>
        </table>
    );
};


interface Props {
    type    : WhiteboardContextType.Type;
    params  : Readonly<Params<string>>
}
interface State {
    dehydratedAgencyManifest?   : ManifestType.AgencyManifest.Dehydrated<string>&{err?:string};
    agencyManifest?             : ManifestType.AgencyManifest.Hydrated<OrderType.Order<string>>;
    vehiclesById?               : Record<number,VehicleType.Vehicle>;
    driversById?                : Record<number,UserType.User>;
    lastUpdatedAt?              : number;
    mapView?                    : boolean; // see https://github.com/TecTransit/TecTransit/issues/467
}
export class Whiteboard extends React.Component<Props,State> {

    private alert                  : Alert = new Alert();
    private manifestMoment         : dayjs.Dayjs;
    private nextAgencyOpenYYYYMMDD : (string|undefined);

    private updateState = ( dehydratedAgencyManifest:(ManifestType.AgencyManifest.Dehydrated<string>&{err?:string}) ) => {
        // If there is only error returned then throw it out
        const amProps = Object.keys(dehydratedAgencyManifest);
        if( amProps.length===1 && amProps[0]==='err' )
            throw Error(dehydratedAgencyManifest.err||'unknown error');
        // Looks like there is something else besides an error
        const usersById      = rehash(dehydratedAgencyManifest.usersById,UserType.hydrate);
        const agencyManifest = ManifestType.AgencyManifest.hydrate(
            dehydratedAgencyManifest,
            rehash(dehydratedAgencyManifest.ordersById,order=>OrderType.hydrate(order,usersById)),
            rehash(dehydratedAgencyManifest.fixedRouteTripsById,frt=>ManifestType.FixedRouteTrip.hydrate(frt,dehydratedAgencyManifest.fixedRouteStopsById))
        );
        // We are getting _current_ drivers of the given VM. I.e. if the VM was created before the
        // last agency schedule change then the whiteboard will show the drivers corresponding to
        // be schedule
        return getApiPromise<UserType.Dehydrated[]>('/api/dispatcher/users','GET',undefined, { inRoles : 'Driver' }).then( dehydrated => {
            if( !dehydrated || dehydrated.err )
                throw Error(`Cannot get drivers (${dehydrated?.err||'unknown error'})`);
            this.setState({
                dehydratedAgencyManifest,
                agencyManifest,
                driversById     : hashById(dehydrated.map(UserType.hydrate)),
                lastUpdatedAt   : Date.now()
            });
        });
    };

    constructor( props:Props ) {
        super(props);
        this.state = {
            mapView : (props.params.kind==='map')
        };
        this.manifestMoment         = dayjs().tz(tectransit.agency.time_zone).add(1,'day').startOf('day'); // always start from next day
        this.nextAgencyOpenYYYYMMDD = getAgencyEarliestOpenAfter(tectransit.agency,this.manifestMoment)?.format("YYYY-MM-DD");
        Promise.all([
            getApiPromise<ManifestType.AgencyManifest.Dehydrated<string>>(`/api/dispatcher/${this.props.type}/agencyManifest`,'GET',{},{date:this.nextAgencyOpenYYYYMMDD},180000)
                .then(this.updateState)
                .catch(err => {
                    throw Error(`Cannot get agency manifest (${err.message})`);
                }),
            getApiPromise<VehicleType.Vehicle[]>('/api/dispatcher/vehicles','GET')
                .then( vehicles => {
                    this.setState({
                        vehiclesById : hashById(vehicles)
                    })
                })
                .catch(err=>{
                    throw Error(`Cannot get vehicles (${err.message})`);
                })
        ]).catch( err => {
            this.alert.set(`Cannot initialize (${err.message})`)
        })
    }
    componentDidUpdate( prevProps:Props ) {
        if( prevProps.params.kind!==this.props.params.kind ) {
            this.setState({
                mapView : this.props.params.kind==='map'
            });
        }
    }
    renderCardsView( whiteboardContext:WhiteboardContextType.WhiteboardContext ) : React.ReactNode {
        const createVehicleManifests = ( dvms:DraftVehicleManifest[] ) : void => {
            if( !this.state.dehydratedAgencyManifest ) {
                this.alert.set('Cannot create vehicle manifests because there is no dehydrated agency manifest');
                return;
            }
            const dehydratedAgencyManifest : ManifestType.AgencyManifest.Dehydrated<string> = {
                ...this.state.dehydratedAgencyManifest,
                vehicleManifests : dvms.map( dvm => {
                    return {
                        ...ManifestType.VehicleManifest.dehydrate({
                            ...dvm.originalVm,
                            steps : dvm.steps
                        }),
                        // Server does not need these values, it needs only dehydrated ids
                        ordersById          : undefined,
                        usersById           : undefined,
                        fixedRouteStopsById : undefined
                    };
                })
            }
            this.setState({
                dehydratedAgencyManifest : undefined,
                agencyManifest           : undefined,
                driversById              : undefined
            });
            getApiPromise<ManifestType.AgencyManifest.Dehydrated<string>>(`/api/dispatcher/${this.props.type}/agencyManifest`,'POST',dehydratedAgencyManifest,{},180000)
                .then( dehydratedAgencyManifest => {
                    // since we have just POSTed the new manifest, we need to show the resulting agency manifest
                    // as it is returned by the server, not as it might be stored in the session storage. This is
                    // why let's wipe the session storage out.
                    sessionStorage.removeItem(whiteboardContext.constructor.name);
                    return this.updateState(dehydratedAgencyManifest);
                })
                .catch( err=> {
                    this.alert.set(err.message);
                });
        };
        const forceRefreshAgencyManifest = () : void => {
            getApiPromise<ManifestType.AgencyManifest.Dehydrated<string>>(`/api/dispatcher/${this.props.type}/agencyManifest`,'GET',{},{noCache:true,date:this.nextAgencyOpenYYYYMMDD},180000)
                .then(this.updateState)
                .catch(err => {
                    throw Error(`Cannot get agency manifest (${err.message})`);
                });
        };
        return (<CardsView
            context                     = { whiteboardContext }
            createVehicleManifests      = { createVehicleManifests }
            forceRefreshAgencyManifest  = { forceRefreshAgencyManifest }
        />);
    }
    renderMapView(whiteboardContext: WhiteboardContextType.WhiteboardContext): React.ReactNode {
        return (
            <MapView
                context={whiteboardContext}
                alert={this.alert}
            />
        );
    }
    render() {
        return MenuItem.withMenuItem(`Agency ${this.props.type==='fixedroute'?'Fixed Routes':'On Demand'} Manifest for ${this.nextAgencyOpenYYYYMMDD}`,( alert ) => {
            this.alert = alert;
            if( !this.nextAgencyOpenYYYYMMDD )
                return (<div style={{textAlign:'center'}}>Cannot find when the agency is open after {this.manifestMoment.format('MM/DD/YYYY')}</div>);
            if( !this.state.dehydratedAgencyManifest || !this.state.agencyManifest )
                return (<div style={{textAlign:'center'}}>Loading agency manifest...</div>);
            if( !this.state.vehiclesById )
                return (<div style={{textAlign:'center'}}>Loading vehicles...</div>);
            if( !this.state.driversById )
                return (<div style={{textAlign:'center'}}>Loading drivers...</div>);
            if( this.state.agencyManifest.progress<100 ) {
                return (
                    <div style={{textAlign:'center'}}>
                        <br/>
                        The calculation of the vehicle manifests has started at&nbsp;
                        <strong>{dayjs(this.state.agencyManifest.calcStartAt).tz(tectransit.agency.time_zone).format(tectransit.timeFormat)}</strong>&nbsp;
                        last updated at&nbsp;
                        <strong>{dayjs(this.state.lastUpdatedAt||Date.now()).tz(tectransit.agency.time_zone).format('HH:mm:ss')}</strong>&nbsp;
                        and is now <strong>{this.state.agencyManifest.progress}%</strong> complete.
                        <br/>
                        <button type="button" className="btn-theme btn-small" style={{margin:'auto'}} onClick={(e) => {
                            getApiPromise<ManifestType.AgencyManifest.Dehydrated<string>>(`/api/dispatcher/${this.props.type}/agencyManifest`,'GET',{},{date:this.nextAgencyOpenYYYYMMDD},180000)
                                .then(this.updateState)
                                .catch( err => {
                                    throw Error(`Cannot get agency manifest (${err.message})`);
                                });
                        }}>
                            Refresh
                        </button>
                    </div>
                );
            }
            // const WhiteboardContext = (this.props.type==='fixedroute') ? FixedRouteWhiteboardContext : OnDemandWhiteboardContext;
            // You can find the source for FixedRouteWhiteboardContext in in git histroy prior to 9/24/2025
            const WhiteboardContext = OnDemandWhiteboardContext; // temporarily force OnDemand until FixedRoute is fixed
            const whiteboardContext = new WhiteboardContext(
                this.props.type,
                this.alert,
                this.state.dehydratedAgencyManifest,
                this.state.agencyManifest,
                this.state.vehiclesById,
                this.state.driversById
            );
            return (
                <div className={this.state.mapView ? undefined : "wrapper"}>
                    {this.state.mapView ? this.renderMapView(whiteboardContext) : this.renderCardsView(whiteboardContext)}
                </div>
            );
        });
    }
}

export default withRouter(Whiteboard);
